import moment from "moment";
import "moment/locale/es";

export const CreateFechaMoment = (fecha, locale) => {
  let inputFormat = "DD/MM/YYYY";
  console.log('CreateFechaMoment', typeof fecha);
  if(typeof fecha !== 'string') fecha = fecha.format(inputFormat);
  if (fecha && fecha.indexOf("/") === -1) {
    inputFormat = "YYYYMMDD";
  }

  if (locale) {
    return fecha ? moment(fecha, inputFormat).locale(locale) : moment().locale(locale);
  } else {
    return fecha ? moment(fecha, inputFormat) : moment();
  }
};

export const CreateFechaHoraMoment = (fecha, locale) => {
  let inputFormat = "DD/MM/YYYY HH:mm:ss";
  console.log('CreateFechaMoment', typeof fecha);
  if(typeof fecha !== 'string') fecha = fecha.format(inputFormat);
  if (fecha && fecha.indexOf("/") === -1) {
    inputFormat = "YYYYMMDD HHmmss";
  }

  if (locale) {
    return fecha ? moment(fecha, inputFormat).locale(locale) : moment().locale(locale);
  } else {
    return fecha ? moment(fecha, inputFormat) : moment();
  }
};

export const InicioAño = (fecha) => {
  return CreateFechaMoment(fecha).startOf("year").format("DD/MM/YYYY");
};

export const InicioMes = (fecha) => {
  return CreateFechaMoment(fecha).startOf("month");
};

export const FinMes = (fecha) => {
  return CreateFechaMoment(fecha).endOf("month");
};

export const NombreMes = (indiceMes) =>
  CreateFechaMoment()
    .month(indiceMes - 1)
    .format("MMMM")
    .toUpperCase();

export const ToSQL = (fecha,separacion) => {
  separacion = separacion === undefined ? "" : separacion;
  if (typeof fecha === "string") {
    return CreateFechaMoment(fecha).format("YYYY"+separacion+"MM"+separacion+"DD");
  } else {
    return fecha.format("YYYY"+separacion+"MM"+separacion+"DD");
  }
};

export const NumeroDiasEnPeriodo = (fechaInicio, fechaFin) => {
  if (!fechaInicio && !fechaFin) return 0;

  let momentInicio, momentFin, numberOfDays;

  if (fechaInicio && !fechaFin) {
    momentInicio = InicioAño(fechaInicio);
    momentFin = CreateFechaMoment(fechaInicio);
  } else {
    momentInicio = CreateFechaMoment(fechaInicio);
    momentFin = CreateFechaMoment(fechaFin);
  }

  numberOfDays = momentFin.diff(momentInicio, "days") + 1;

  if (isNaN(numberOfDays)) {
    throw new Error("El formato de alguna de las fechas no es correcto");
  }

  return numberOfDays;
};

export const FechaPdf = (hora=false) => {
  if(hora === true)
  return moment().format('LLLL')
  else
  return moment().format("dddd, D MMMM, YYYY");
};

export const CreateFecha = (fecha) => {
  return moment(fecha).format("L");
};

export const formatDate = (value) => {
  return moment(value).format("DD/MM/YYYY");
};

export const formatDateTime = (value) => {
  return moment(value).format("DD/MM/YYYY HH:mm:ss");
};

export const FechaConHora = (value) => {
  return `${moment(value).format("L")} ${moment(value).format("LTS")}`;
};

export const DiferenciaEnMeses = (compareDate) => {
  let now = moment(Date.now()).format("YYYY/MM/DD");
  let compare = moment(compareDate).format("YYYY/MM/DD");

  now = moment(now.split("/"));
  compare = moment(compare.split("/"));

  return now.diff(compare, "month", true);
};

export const DATE_TIME_FORMAT = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
};

export const DATE_FORMAT = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const DateTimeFormatter = (format, locale = "es") => Intl.DateTimeFormat(locale, format);

/**
 * Returns
 *
 *  1 si date1 es mayor
 *
 *  0 si date1  y date2 son iguales
 *
 *  -1 si date1 es menor
 *
 * @param {Date} date1
 * @param {Date} date2
 */
export const DateTimeComparer = (date1, date2) => {
  //console.log("TCL: DateTimeComparer -> date1, date2", [date1, date2]);

  const time1 = date1.getTime();
  const time2 = date2.getTime();

  if (time1 > time2) {
    return 1;
  } else if (time1 < time2) {
    return -1;
  }

  return 0;
};

/**
 * Returns
 *
 *  1 si date1 es mayor
 *
 *  0 si date1  y date2 son iguales
 *
 *  -1 si date1 es menor
 *
 * @param {Date} date1
 * @param {Date} date2
 */
export const DateComparer = (date1, date2) => {
  //console.log("TCL: DateTimeComparer -> date1, date2", [date1, date2]);

  clearTime(date1);
  clearTime(date2);

  // console.log("TCL: DateTimeComparer after clear-> date1, date2", [
  //   date1,
  //   date2
  // ]);

  const time1 = date1.getTime();
  const time2 = date2.getTime();

  if (time1 > time2) {
    return 1;
  } else if (time1 < time2) {
    return -1;
  }

  return 0;
};

/**
 *
 * Devuelve la fecha en formato AAAAMMDD
 *
 * @param {Date} date
 */
export const sqlDateFormat = (date) =>
  DateTimeFormatter(DATE_FORMAT)
    .formatToParts(date)
    .filter((f) => f.type !== "literal")
    .map((m) => m.value)
    .reverse()
    .join("");

/**
 *
 * Elimina la parte de tiempo de la fecha
 *
 * @param {Date} date
 */
const clearTime = (date) => {
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setMilliseconds(0);
};

export const isoStringToDate = (string) => {
  if (!string || string.length === 0) {
    return "";
  }

  return new Date(string);
};

export const isoStringToDateString = (dateString, format) => {
  if (!dateString || dateString.length === 0) {
    return "";
  }

  return DateTimeFormatter(format).format(isoStringToDate(dateString));
};

export const stringToISODate = (string) => new Date(Date.parse(string.split("/").reverse().join("-"))).toISOString();

export const stringToDate = (string) => new Date(Date.parse(string.split("/").reverse().join("-")));
